// extracted by mini-css-extract-plugin
export default {"magasinsTable":"users-table_magasinsTable__CCmr1","sortIcons":"users-table_sortIcons__y5vgM","active":"users-table_active__9ppyf","name":"users-table_name__3H2KS"};